import React, { useEffect } from 'react';
import { prop } from 'ramda';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getURLParam } from 'js/utils/url.util';
import { usePrevious } from 'js/hooks/usePrevious';
import { scrollService } from 'js/services/scroll.service';
import { useDeviceSelector, useUserSelector } from 'js/store/hooks';

import * as hocs from './hocs';
import * as hooks from './hooks';
import * as helpers from './helpers';
import { Layout } from './components/Layout';

export const PageBare = ({ page, isLoading, fetchPageInfo }) => {
    const location = useLocation();
    const role = useUserSelector(prop('role'));
    const isPageAsPopUpDisabled = getURLParam(location.search, 'noPageAsPopup') === '1' || role === 'admin';

    const prevPage = usePrevious(page, page);
    const htmlBaseClasses = useDeviceSelector(prop('htmlBaseClasses'));

    hooks.useLegacyPageRenderedTrigger({ page });
    hooks.useCMSIntegration({ page, fetchPageInfo });

    const actualPage = page ?? prevPage;

    useEffect(() => {
        if (page?.friendlyURL === prevPage?.friendlyURL) {
            return;
        }

        scrollService.scrollTo(0);
    }, [page?.friendlyURL, prevPage?.friendlyURL]);

    if (!actualPage) {
        return null;
    }

    const pageStyles = helpers.getPageStyles({ page: actualPage });

    return <>
        <Helmet htmlAttributes={{ class: helpers.getPageClassNames(actualPage.rootClassNames, htmlBaseClasses) }} >
            <style type="text/css">{pageStyles}</style>
        </Helmet>
        {(!actualPage.showAsPopUp || isPageAsPopUpDisabled) && <Layout page={actualPage} isLoading={isLoading} />}
    </>;
};

export const Page = hocs.withCommonPage(PageBare);
